export default __webpack_public_path__ + "static/media/Levven_logo.80c2c0bf.png";